
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.634 11.694c-.365-1.176-1.335-2.71-1.81-3.416-.34-.506-1.18-.506-1.521 0-.47.7-1.43 2.216-1.802 3.387-.032.1-.069.195-.09.3a2.266 2.266 0 00-.071.511 2.726 2.726 0 002.724 2.724 2.726 2.726 0 002.723-2.724c0-.154-.027-.328-.071-.514-.02-.092-.053-.18-.082-.268m-2.57 1.673a.874.874 0 01-.873-.873.873.873 0 11.873.873zm9.238-7.356a10.616 10.616 0 011.392 5.258c0 5.897-4.797 10.694-10.694 10.694C5.103 21.963.306 17.166.306 11.27c0-1.911.51-3.703 1.392-5.258.013-.03.024-.06.04-.09a.87.87 0 01.092-.126 10.759 10.759 0 013.696-3.696.865.865 0 01.127-.092c.029-.017.06-.027.09-.04a10.613 10.613 0 0110.514 0c.03.013.06.023.09.04a.865.865 0 01.127.092 10.76 10.76 0 013.696 3.695c.033.04.064.081.091.128.018.029.028.06.04.09zM11 20.13c4.577 0 8.353-3.488 8.813-7.944h-.961a.917.917 0 010-1.834h.961a8.794 8.794 0 00-.728-2.692l-.827.477a.915.915 0 11-.917-1.588l.822-.475a8.929 8.929 0 00-1.969-1.969l-.474.822a.917.917 0 01-1.588-.916l.477-.827a8.782 8.782 0 00-2.692-.729v.962a.917.917 0 11-1.834 0v-.962a8.782 8.782 0 00-2.692.729l.477.827a.917.917 0 01-1.588.916l-.474-.822a8.929 8.929 0 00-1.97 1.97l.823.474a.917.917 0 01-.917 1.588l-.827-.477a8.794 8.794 0 00-.728 2.692h.961a.917.917 0 010 1.834h-.961c.46 4.456 4.236 7.944 8.813 7.944z","fill":"#8E8E92","fill-rule":"evenodd"}})])
          )
        }
      }
    